import { removeRedundantObjects } from 'utils/group';
import {
  listFiles,
  listFilesNext,
  listTrashFiles,
  restoreTrashFile,
  listPropertyFolderFiles,
  listShareBuckets,
  listPropertyFolderFilesNext,
  listSharedFiles,
  listSharedFilesNext,
  listTrashFilesNext,
} from '../thunks/files';
import { handlePending, handleRejected } from './utils';

export const filesReducers = (builder) => {
  // List files
  builder
    .addCase(listFiles.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.items.value = files;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loading = false;
    })
    .addCase(listFiles.pending, (state) => {
      handlePending(state, 'items');
      state.items.value = [];
    })
    .addCase(listFiles.rejected, (state) => handleRejected(state, 'items'));

  // List files next
  builder
    .addCase(listFilesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      const filteredItems = removeRedundantObjects({
        array: [...state.items.value, ...files],
        property: 'oid',
      });
      state.items.value = filteredItems;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loadingNext = false;
    })
    .addCase(listFilesNext.pending, (state) => {
      state.items.loadingNext = true;
    })
    .addCase(listFilesNext.rejected, (state) => {
      state.items.loadingNext = false;
    });

  // List shared buckets
  builder
    .addCase(listShareBuckets.fulfilled, (state, action) => {
      const { data, storeBucketOnly } = action.payload;

      const transformedFiles = data?.map((file) => ({
        ...file,
        oid: file.id,
        format: 'Folder',
      }));

      state.sharedBuckets = transformedFiles;

      if (!storeBucketOnly) {
        state.items.value = transformedFiles;
        state.items.loading = false;
      }
    })
    .addCase(listShareBuckets.pending, (state) => {
      handlePending(state, 'items');
      state.items.value = [];
    })
    .addCase(listShareBuckets.rejected, (state) => handleRejected(state, 'items'));

  // List shared files
  builder
    .addCase(listSharedFiles.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.items.value = files;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loading = false;
    })
    .addCase(listSharedFiles.pending, (state) => {
      handlePending(state, 'items');
      state.items.value = [];
    })
    .addCase(listSharedFiles.rejected, (state) => handleRejected(state, 'items'));

  // List shared files next
  builder
    .addCase(listSharedFilesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      const filteredItems = removeRedundantObjects({
        array: [...state.items.value, ...files],
        property: 'oid',
      });
      state.items.value = filteredItems;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loadingNext = false;
    })
    .addCase(listSharedFilesNext.pending, (state) => {
      state.items.loadingNext = true;
    })
    .addCase(listSharedFilesNext.rejected, (state) => {
      state.items.loadingNext = false;
    });

  // List property folder files
  builder
    .addCase(listPropertyFolderFiles.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.items.value = files;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loading = false;
    })
    .addCase(listPropertyFolderFiles.pending, (state) => {
      handlePending(state, 'items');
      state.items.value = [];
    })
    .addCase(listPropertyFolderFiles.rejected, (state) => handleRejected(state, 'items'));

  // List property folder files next
  builder
    .addCase(listPropertyFolderFilesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      const filteredItems = removeRedundantObjects({
        array: [...state.items.value, ...files],
        property: 'oid',
      });
      state.items.value = filteredItems;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loadingNext = false;
    })
    .addCase(listPropertyFolderFilesNext.pending, (state) => {
      state.items.loadingNext = true;
    })
    .addCase(listPropertyFolderFilesNext.rejected, (state) => {
      state.items.loadingNext = false;
    });

  /* bin page */
  // List trash files
  builder
    .addCase(listTrashFiles.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.items.value = files;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loading = false;
    })
    .addCase(listTrashFiles.pending, (state) => {
      handlePending(state, 'items');
      state.items.value = [];
    })
    .addCase(listTrashFiles.rejected, (state) => handleRejected(state, 'items'));

  // List trash files next
  builder
    .addCase(listTrashFilesNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      const filteredItems = removeRedundantObjects({
        array: [...state.items.value, ...files],
        property: 'oid',
      });
      state.items.value = filteredItems;
      state.items.offset = offset;
      state.items.hasMore = files.length > 0;
      state.items.loadingNext = false;
    })
    .addCase(listTrashFilesNext.pending, (state) => {
      state.items.loadingNext = true;
    })
    .addCase(listTrashFilesNext.rejected, (state) => {
      state.items.loadingNext = false;
    });

  // Restore trash file
  builder.addCase(restoreTrashFile.fulfilled, (state, action) => {
    const file = action.payload?.data || {};
    const items = [...state.items.value];
    const index = items.findIndex((item) => item.id === file.id || item.oid === file.oid);
    if (index !== -1) {
      items.splice(index, 1);
    }
    state.items.value = items;
  });
};
